export const FirebaseConfig = {
  apiKey: process.env.API_KEY,
  authDomain: "chris-lane-portfolio.firebaseio.com",
  databaseURL: "https://chris-lane-portfolio.firebaseio.com"
};
